module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4",
    attrs: {
      "icon": "docs"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_vm._v("Assemblage")])]), _vm._v(" "), _c('action-bar', {
    staticClass: "px-4 pb-6",
    attrs: {
      "back": {
        name: 'home'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white"
  }, [_c('form', {
    staticClass: "p-4 md:p-6 space-y-6",
    attrs: {
      "id": "assemblage"
    }
  }, [_c('section', {
    staticClass: "space-y-3"
  }, [_c('h2', {
    staticClass: "text-lg uppercase text-secondary font-semibold"
  }, [_vm._v("ACQUÉREUR")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Raison sociale "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "w-full",
    attrs: {
      "id": "id_detenteur",
      "on-change": _vm.changeDet,
      "options": _vm.detenteursFiltred,
      "filterable": false
    },
    on: {
      "search": _vm.onSearch
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "space-y-3"
  }, [_c('h2', {
    staticClass: "text-lg uppercase text-secondary font-semibold"
  }, [_vm._v("ÉQUIPEMENT INSTALLÉ")]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Type "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type_equipement),
      expression: "type_equipement"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "required": "",
      "type": "radio",
      "name": "type_equipement",
      "id": "radio-clim",
      "value": "Climatisation"
    },
    domProps: {
      "checked": _vm._q(_vm.type_equipement, "Climatisation")
    },
    on: {
      "change": function($event) {
        _vm.type_equipement = "Climatisation"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition\n                       peer-checked:bg-vert peer-checked:text-white peer-checked:shadow\n                       flex items-center justify-between",
    attrs: {
      "for": "radio-clim"
    }
  }, [_c('span', [_vm._v("Climatisation")])])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type_equipement),
      expression: "type_equipement"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "required": "",
      "type": "radio",
      "name": "type_equipement",
      "id": "radio-pompe",
      "value": "Pompe à chaleur"
    },
    domProps: {
      "checked": _vm._q(_vm.type_equipement, "Pompe à chaleur")
    },
    on: {
      "change": function($event) {
        _vm.type_equipement = "Pompe à chaleur"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition\n                       peer-checked:bg-vert peer-checked:text-white peer-checked:shadow\n                       flex items-center justify-between",
    attrs: {
      "for": "radio-pompe"
    }
  }, [_c('span', [_vm._v("Pompe à chaleur")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fluide frigorigène "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.id_fluide),
      expression: "id_fluide",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "name": "id_fluide",
      "id": "fluide"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.id_fluide = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Sélectionnez un fluide")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("R-134a")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("R-32")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("R-410A")])])])]), _vm._v(" "), _c('section', {
    staticClass: "space-y-3"
  }, [_c('h2', {
    staticClass: "text-lg uppercase text-secondary font-semibold"
  }, [_vm._v("INFORMATIONS")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Période de validité du contrat (en mois) "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.validite),
      expression: "validite",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "validatedRange",
      "name": "periode_validite",
      "type": "number"
    },
    domProps: {
      "value": (_vm.validite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.validite = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col md:col-span-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Autres détails")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details),
      expression: "details"
    }],
    staticClass: "input min-h-[110px] resize-y",
    attrs: {
      "title": "otherDetails",
      "name": "remarque",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "space-y-4"
  }, [_c('h2', {
    staticClass: "text-lg uppercase text-secondary font-semibold"
  }, [_vm._v("SIGNATURE")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom acquéreur "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nom_acquereur),
      expression: "nom_acquereur"
    }],
    staticClass: "input",
    attrs: {
      "title": "clientName",
      "type": "text",
      "name": "nom_acquereur",
      "required": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nom_acquereur)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nom_acquereur = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn add btn-full inline-flex items-center justify-center gap-2 rounded-lg px-4 py-3 shadow-sm hover:shadow transition",
    class: [
      _vm.contratIsValid ? 'bg-primary text-white' : 'bg-gray-300 text-gray-500 italic pointer-events-none disabled'
    ],
    attrs: {
      "id": "main-action",
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerSignature($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-checktodo"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm sm:text-base"
  }, [_c('strong', [_vm._v("Signer et clôturer")]), _vm._v(" le contrat d'assemblage\n            ")])]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "signature": _vm.signature,
      "clearOnClose": true
    },
    on: {
      "signatureUpdated": _vm.updateSignature,
      "close": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b85e04","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/assemblage/ContratAssemblage.vue
// module id = 1023
// module chunks = 0